import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import Sidebar from './Sidemenu'; 
import { Button, Modal, Form,InputGroup, FormControl,Tabs, Tab } from 'react-bootstrap';
import { FaBell, FaSearch, FaCaretDown, FaCog, FaTimes, FaCheck, FaSave } from 'react-icons/fa';

const Forms = () => {
    const [showAccountOptions, setShowAccountOptions] = useState('');
    const [category, setCategory] = useState('');
    const [showDetails, setShowDetails] = useState('');
    const [Fielddisplayed, setFielddisplayed] = useState('');
   
    const [username, setusername] = useState('');
    const [formattributes, setformattributes] = useState('');
    const [submitaction,setsubmitaction] = useState('');
    const [Fieldssubmitaction,setFieldssubmitaction] = useState('');
    const [urlmessage, seturlmessage] = useState('');
    const [description ,setdescription] = useState('');
    
    
  
  const [language, setLanguage] = useState('');
  const [published, setPublished] = useState('');
  const [publishAt, setPublishAt] = useState('');
  const [unpublishAt, setUnpublishAt] = useState('');
  const [showFieldsInput, setShowFieldsInput] = useState('');
const [selectedFieldType, setSelectedFieldType] = useState('');
const [showActionsInput, setShowActionsInput] = useState('');
const [selectedAction, setSelectedAction] = useState('');
const [showPopup, setShowPopup] = useState(false);

const [showEmailModal, setShowEmailModal] = useState('');
const [showDateModal, setShowDateModal] = useState('');
const [showTextModal, setShowTextModal] = useState('');
const [showTextareaModal, setShowTextareaModal] = useState('');
const [showurlModal, setShowurlModal] = useState('');
const [email, setEmail] = useState('');

  const [selectedOption, setSelectedOption] = useState('');
  const [showInputField, setShowInputField] = useState('');
  const [showValidationOptions, setShowValidationOptions] = useState('');
  const [showGeneralOptions, setShowGeneralOptions] = useState('');
  const [selectedValidation, setSelectedValidation] = useState('');
  const [label, setLabel] = useState('');
  const [defaultValue, setDefaultValue] = useState('');
  const [inputPlaceholder, setInputPlaceholder] = useState('');

  const handleModalOpen = () => {
    setShowEmailModal(true);
    setShowDateModal(true);
    setShowTextModal(true);
    setShowTextareaModal(true);
    setShowurlModal(true);
  };

  const handleContactFieldClick = () => {
    setSelectedOption('Contact Field');
  };

  const handleValidationClick = () => {
    setSelectedOption('Validation');
  };

  const handleGeneralClick = () => {
    setSelectedOption('General');
  };


const handleSelectChange = (e) => {
  setFieldssubmitaction(e.target.value);
  if (e.target.value === 'Email') {
    setShowEmailModal(true);
  }else if (e.target.value === 'Date') {
    setShowDateModal(true);
  }else if (e.target.value === 'Text') {
    setShowTextModal(true);
  }else if (e.target.value === 'TextArea') {
    setShowTextareaModal(true);
  } else if (e.target.value === 'URL') {
    setShowurlModal(true);
  }
};




 


  
  

 

    const toggleAccountOptions = () => {
        setShowAccountOptions(!showAccountOptions);
    };

    const toggleActionsInput = () => {
        setShowActionsInput(!showActionsInput);
    };

    const handleActionSelect = (action) => {
        setSelectedAction(action);
       
    };

    const handleDetailsClick = () => {
    setShowDetails(true);
    setShowFieldsInput(false);
    setShowActionsInput(false);
  };

  const handleFieldsClick = () => {
    setShowDetails(false);
    setShowFieldsInput(true);
    setShowActionsInput(false);
  };

  const handleActionsClick = () => {
    setShowDetails(false);
    setShowFieldsInput(false);
    setShowActionsInput(true);
  };


    const handleCategorySelect = (selectedCategory) => {
        setCategory(selectedCategory);
        
      };
    
      const handleLanguageSelect = (selectedLanguage) => {
        setLanguage(selectedLanguage);
      };
    
      const handlePublishAtSelect = (value) => {
        setPublishAt(value);
      };
    
      const handleUnpublishAtSelect = (value) => {
        setUnpublishAt(value);
      };
    
    

    const handlePublishedSelect = (value) => {
        setPublished(value === 'Yes');
      };

      const handleSaveAndClose = async () => {
        try {
            const data = {
                username,
                formattributes,
                submitaction,
                urlmessage,
                description,
                selectedAction,
                Fielddisplayed,
                Fieldssubmitaction,
                

            };
    
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/formdetails`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
    
            if (response.ok) {
                console.log('Form details saved successfully');
                // You can add additional logic here if needed
            } else {
                console.error('Failed to save form details:', response.statusText);
                // Handle the error here if needed
            }
        } catch (error) {
            console.error('An error occurred:', error);
            // Handle the error here
        }
    };
    
    

    return (
        <div style={{ display: 'flex' }}>
            <Sidebar />
            <div>
                {/* First rectangle */}
                <div className="content-container" style={{ border: '1px solid #ccc', marginLeft: '10px', marginTop: '-15px', paddingLeft: '10px', paddingRight: '10px', width: '1300px', height: '100px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <FaBell style={{ fontSize: '24px', marginRight: '20px' }} />
                        <FaSearch style={{ fontSize: '24px' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {/* Profile Box */}
                        <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                            <div style={{ border: '1px solid #ccc', borderRadius: '50%', width: '40px', height: '40px', overflow: 'hidden', marginRight: '19px' }}>
                                {/* Add your profile image or icon here */}
                            </div>
                            <span style={{ marginRight: '2px' }}>EPICX</span>
                            <div style={{ cursor: 'pointer' }} onClick={toggleAccountOptions}>
                                <FaCaretDown />
                            </div>
                            {showAccountOptions && (
                                <div style={{ position: 'absolute', top: '100%', right: '0', background: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '8px', zIndex: '1' }}>
                                    <p>Account</p>
                                    <p>Logout</p>
                                </div>
                            )}
                        </div>

                        {/* Settings Icon */}
                        <div style={{ cursor: 'pointer', marginLeft: '10px' }}>
                            <FaCog style={{ fontSize: '24px', marginLeft: '2px', marginRight: '19px' }} />
                        </div>
                    </div>

                </div>
                {/* Second rectangle */}
      <div className="content-container" style={{ border: '1px solid #ccc', marginLeft: '10px', paddingLeft: '10px', paddingRight: '10px', width: '1300px', height: '80px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: '1000' }}>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: '30px', marginLeft: '30px' }}>
          <span>New Campaign Form</span>
        </div>
        <div className="d-flex">
          <button className="btn btn-white" style={{ border: '1px solid #ccc' }}  onClick={handleSaveAndClose} >
            <FaSave className="mr-0" style={{ color: '#007bff' }} /> Save & Close
          </button>
          <button className="btn btn-white mx-2" style={{ border: '1px solid #ccc' }} >
            <FaCheck className="" style={{ color: '#007bff' }} /> Save
          </button>
          <button className="btn btn-white" style={{ border: '1px solid #ccc' }} >
            <FaTimes className="" style={{ color: 'red' }} /> Cancel
          </button>
        </div>
      </div>

      {/* Form Controls */}
      <div className="content-container mt-5" style={{ border: '1px solid #ccc', paddingLeft: '10px', paddingRight: '10px', width: '250px', height: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', position: 'absolute', top: '120px', right: '10px', zIndex: '999' }}>
        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%' }}>
          <label htmlFor="category" style={{ marginBottom: '5px', textAlign: 'left', width: '100px', fontWeight: 'bold' }}>Category</label>
          <select className="form-control mb-2" id="category" value={category} onChange={(e) => handleCategorySelect(e.target.value)} style={{ width: '107%' }}>
            <option value=""></option>
            <option value="Category 1">Uncategorized</option>
            <option value="Category 2">Create New Category..</option>
          </select>
        </div>

        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%' }}>
          <label htmlFor="language" style={{ marginBottom: '5px', textAlign: 'left', width: '100px', fontWeight: 'bold' }}>Language</label>
          <select className="form-control mb-2" id="language" value={language} onChange={(e) => handleLanguageSelect(e.target.value)} style={{ width: '107%' }}>
            <option value=""></option>
            <option value="English">English</option>
            <option value="Spanish">Spanish</option>
          </select>
        </div>

        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%' }}>
          <label htmlFor="blockSearchEngines" style={{ marginBottom: '5px', textAlign: 'left', width: '200px', fontWeight: 'bold' }}>Published </label>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '60%' }}>
            <label style={{ width: '35%' }}>
              <input type="radio" value="Yes" checked={published} onChange={() => handlePublishedSelect('Yes')} /> Yes
            </label>
            <label style={{ width: '45%' }}>
              <input type="radio" value="No" checked={!published} onChange={() => handlePublishedSelect('No')} /> No
            </label>
          </div>
        </div>

        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%' }}>
          <label htmlFor="publishAt" style={{ marginBottom: '5px', textAlign: 'left', width: '250px', fontWeight: 'bold' }}>Publish at (Date and Time)</label>
          <input type="datetime-local" className="form-control mb-2" id="publishAt" value={publishAt} onChange={(e) => handlePublishAtSelect(e.target.value)} style={{ width: '107%' }} />
        </div>

        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%' }}>
          <label htmlFor="unpublishAt" style={{ marginBottom: '5px', textAlign: 'left', width: '250px', fontWeight: 'bold' }}>Unpublish at (Date and Time)</label>
          <input type="datetime-local" className="form-control mb-2" id="unpublishAt" value={unpublishAt} onChange={(e) => handleUnpublishAtSelect(e.target.value)} style={{ width: '107%' }} />
        </div>

        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%' }}>
          <label htmlFor="blockSearchEngines" style={{ marginBottom: '5px', textAlign: 'left', width: '200px', fontWeight: 'bold' }}>Block search engines from indexing this file </label>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '60%' }}>
            <label style={{ width: '35%' }}>
              <input type="radio" value="Yes" checked={published} onChange={() => handlePublishedSelect('Yes')} /> Yes
            </label>
            <label style={{ width: '45%' }}>
              <input type="radio" value="No" checked={!published} onChange={() => handlePublishedSelect('No')} /> No
            </label>
          </div>
        </div>
      </div>
      <div className="content-container mt-5">
      <div className="form-group row mt-5">
        <div className="col">
        <button className="btn btn-primary mr-0" style={{ marginTop: '-30px' }} onClick={() => handleDetailsClick('Details')}>Details</button>
<button className="btn btn-primary mr-0" style={{ marginTop: '-30px' }} onClick={() => handleFieldsClick('Fields')}>Fields</button>
<button className="btn btn-primary mr-0" style={{ marginTop: '-30px' }} onClick={() => handleActionsClick('Actions')}>Actions</button>

        </div>
      </div>

      {showDetails && (
  <div className="form-group row">
    <div className="col">
      <p style={{marginLeft:'10px'}}>Name</p>
      <input type="text" className="form-control" value={username} onChange={(e) => setusername(e.target.value)}style={{ width: '300px',marginLeft:"10px" }} />
      
    </div>
    <div className="col">
      <p style={{marginLeft:"-20px" }}>Form attributes</p>
      <input type="text" className="form-control"  value={formattributes} onChange={(e) => setformattributes(e.target.value)} style={{ width: '300px',marginLeft:"-20px" }} />
    </div>
    
   
      <div className="row">
      <div className="col">
    <p style={{marginLeft:"10px",marginTop:'50px'}}>Successful Submit Action</p>
    <select className="form-control" value={submitaction} onChange={(e) => setsubmitaction(e.target.value)} style={{ width: '300px',marginLeft:"10px"}}>
        <option value="remain"> </option>
        <option value="remain">Remain at form</option>
        <option value="redirect">Redirect URL</option>
        <option value="display">Display message</option>
    </select>
</div>

    <div className="col">
        <p style={{marginLeft:"-10px",marginTop:'50px' }}>Redirect URL/Message</p>
        <input type="text" className="form-control" value = {urlmessage} onChange={(e) => seturlmessage(e.target.value)} style={{ width: '300px',marginLeft:"-10px" }} />
    </div>
</div>
<div className="col">
      <p style={{marginLeft:"20px",marginTop:"50px" }}>Description</p>
      <input type="text" className="form-control" value = {description} onChange={(e) => setdescription(e.target.value)} style={{ width: '300px',marginLeft:"20px",height:'100px'}} />
    </div>

  </div>
  
)}



    

      
<>
      {showFieldsInput && (
        <div className="row">
          <div className="col">
            <select
              className="form-control"
              value={Fieldssubmitaction}
              onChange={handleSelectChange}
              style={{ width: '300px', marginLeft: '30px' }}
            >
              <option value="">Select Field</option>
              <option value="Date">Date</option>
              <option value="Email">Email</option>
              <option value="Text">Text</option>
              <option value="TextArea">TextArea</option>
              <option value="URL">URL</option>
            </select>
          </div>
        </div>
      )}



<Modal show={showEmailModal} onHide={() => setShowEmailModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="row">
              <div className="col-auto" onClick={handleContactFieldClick} style={{ cursor: 'pointer' }}>Contact Field</div>
              <div className="col-auto" onClick={handleValidationClick} style={{ cursor: 'pointer' }}>Validation</div>
              <div className="col-auto" onClick={handleGeneralClick} style={{ cursor: 'pointer' }}>General</div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedOption === 'Contact Field' && (
            <Form.Group controlId="formInputLabel">
            <Form.Label>Choose field</Form.Label>
            <Form.Control
              as="select"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
            >
              <option value=""></option>
              <option value="Option 1">Email</option>
              <option value="Option 2">Mobile</option>
              <option value="Option 3">City</option>
              <option value="Option 4">State</option>
              
            </Form.Control>
          </Form.Group>
          
          )}
          {selectedOption === 'Validation' && (
            <div>
              <div className="d-flex align-items-center">
                <span>Required</span>
                <Button
                  variant={selectedValidation === 'Yes' ? 'success' : 'outline-secondary'}
                  onClick={() => setSelectedValidation('Yes')}
                  style={{ marginRight: '-45px' }}
                >
                  Yes
                </Button>
                <Button
                  variant={selectedValidation === 'No' ? 'danger' : 'outline-secondary'}
                  onClick={() => setSelectedValidation('No')}
                >
                  No
                </Button>
              </div>
            </div>
          )}
          {selectedOption === 'General' && (
            <div>
              <Form.Group controlId="formInputLabel">
                <Form.Label>Label</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter label"
                  value={label}
                  onChange={(e) => setLabel(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formInputDefaultValue">
                <Form.Label>Default Value</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter default value"
                  value={defaultValue}
                  onChange={(e) => setDefaultValue(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formInputPlaceholder">
                <Form.Label>Input Placeholder</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter input placeholder"
                  value={inputPlaceholder}
                  onChange={(e) => setInputPlaceholder(e.target.value)}
                />
              </Form.Group>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEmailModal(false)}>Close</Button>
          <Button variant="primary" onClick={() => {
            setShowEmailModal(false);
            console.log(selectedOption); // Selected option from Contact Field
            console.log(selectedValidation); // Selected validation option
          }}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDateModal} onHide={() => setShowDateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="row">
              <div className="col-auto" onClick={handleContactFieldClick} style={{ cursor: 'pointer' }}>Contact Field</div>
              <div className="col-auto" onClick={handleValidationClick} style={{ cursor: 'pointer' }}>Validation</div>
              <div className="col-auto" onClick={handleGeneralClick} style={{ cursor: 'pointer' }}>General</div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedOption === 'Contact Field' && (
            <Form.Group controlId="formInputLabel">
            <Form.Label>Choose field</Form.Label>
            <Form.Control
              as="select"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
            >
              <option value=""></option>
              <option value="Option 1">Email</option>
              <option value="Option 2">Mobile</option>
              <option value="Option 3">City</option>
              <option value="Option 4">State</option>
              
            </Form.Control>
          </Form.Group>
          
          )}
          {selectedOption === 'Validation' && (
            <div>
              <div className="d-flex align-items-center">
                <span>Required</span>
                <Button
                  variant={selectedValidation === 'Yes' ? 'success' : 'outline-secondary'}
                  onClick={() => setSelectedValidation('Yes')}
                  style={{ marginRight: '-45px' }}
                >
                  Yes
                </Button>
                <Button
                  variant={selectedValidation === 'No' ? 'danger' : 'outline-secondary'}
                  onClick={() => setSelectedValidation('No')}
                >
                  No
                </Button>
              </div>
            </div>
          )}
          {selectedOption === 'General' && (
            <div>
              <Form.Group controlId="formInputLabel">
                <Form.Label>Label</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter label"
                  value={label}
                  onChange={(e) => setLabel(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formInputDefaultValue">
                <Form.Label>Default Value</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter default value"
                  value={defaultValue}
                  onChange={(e) => setDefaultValue(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formInputPlaceholder">
                <Form.Label>Input Placeholder</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter input placeholder"
                  value={inputPlaceholder}
                  onChange={(e) => setInputPlaceholder(e.target.value)}
                />
              </Form.Group>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDateModal(false)}>Close</Button>
          <Button variant="primary" onClick={() => {
            setShowDateModal(false);
            console.log(selectedOption); // Selected option from Contact Field
            console.log(selectedValidation); // Selected validation option
          }}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showTextModal} onHide={() => setShowTextModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="row">
              <div className="col-auto" onClick={handleContactFieldClick} style={{ cursor: 'pointer' }}>Contact Field</div>
              <div className="col-auto" onClick={handleValidationClick} style={{ cursor: 'pointer' }}>Validation</div>
              <div className="col-auto" onClick={handleGeneralClick} style={{ cursor: 'pointer' }}>General</div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedOption === 'Contact Field' && (
            <Form.Group controlId="formInputLabel">
            <Form.Label>Choose field</Form.Label>
            <Form.Control
              as="select"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
            >
              <option value=""></option>
              <option value="Option 1">Email</option>
              <option value="Option 2">Mobile</option>
              <option value="Option 3">City</option>
              <option value="Option 4">State</option>
              
            </Form.Control>
          </Form.Group>
          
          )}
          {selectedOption === 'Validation' && (
            <div>
              <div className="d-flex align-items-center">
                <span>Required</span>
                <Button
                  variant={selectedValidation === 'Yes' ? 'success' : 'outline-secondary'}
                  onClick={() => setSelectedValidation('Yes')}
                  style={{ marginRight: '-45px' }}
                >
                  Yes
                </Button>
                <Button
                  variant={selectedValidation === 'No' ? 'danger' : 'outline-secondary'}
                  onClick={() => setSelectedValidation('No')}
                >
                  No
                </Button>
              </div>
            </div>
          )}
          {selectedOption === 'General' && (
            <div>
              <Form.Group controlId="formInputLabel">
                <Form.Label>Label</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter label"
                  value={label}
                  onChange={(e) => setLabel(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formInputDefaultValue">
                <Form.Label>Default Value</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter default value"
                  value={defaultValue}
                  onChange={(e) => setDefaultValue(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formInputPlaceholder">
                <Form.Label>Input Placeholder</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter input placeholder"
                  value={inputPlaceholder}
                  onChange={(e) => setInputPlaceholder(e.target.value)}
                />
              </Form.Group>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowTextModal(false)}>Close</Button>
          <Button variant="primary" onClick={() => {
            setShowTextModal(false);
            console.log(selectedOption); // Selected option from Contact Field
            console.log(selectedValidation); // Selected validation option
          }}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
                  <Modal show={showTextareaModal} onHide={() => setShowTextareaModal(false)}>
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <div className="row">
                        <div className="col-auto" onClick={handleContactFieldClick} style={{ cursor: 'pointer' }}>Contact Field</div>
                        <div className="col-auto" onClick={handleValidationClick} style={{ cursor: 'pointer' }}>Validation</div>
                        <div className="col-auto" onClick={handleGeneralClick} style={{ cursor: 'pointer' }}>General</div>
                      </div>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {selectedOption === 'Contact Field' && (
                      <Form.Group controlId="formInputLabel">
                      <Form.Label>Choose field</Form.Label>
                      <Form.Control
                        as="select"
                        value={label}
                        onChange={(e) => setLabel(e.target.value)}
                      >
                        <option value=""></option>
                        <option value="Option 1">Email</option>
                        <option value="Option 2">Mobile</option>
                        <option value="Option 3">City</option>
                        <option value="Option 4">State</option>
                        
                      </Form.Control>
                    </Form.Group>
                    
                    )}
                    {selectedOption === 'Validation' && (
                      <div>
                        <div className="d-flex align-items-center">
                          <span>Required</span>
                          <Button
                            variant={selectedValidation === 'Yes' ? 'success' : 'outline-secondary'}
                            onClick={() => setSelectedValidation('Yes')}
                            style={{ marginRight: '-45px' }}
                          >
                            Yes
                          </Button>
                          <Button
                            variant={selectedValidation === 'No' ? 'danger' : 'outline-secondary'}
                            onClick={() => setSelectedValidation('No')}
                          >
                            No
                          </Button>
                        </div>
                      </div>
                    )}
                    {selectedOption === 'General' && (
                      <div>
                        <Form.Group controlId="formInputLabel">
                          <Form.Label>Label</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter label"
                            value={label}
                            onChange={(e) => setLabel(e.target.value)}
                          />
                        </Form.Group>
                        <Form.Group controlId="formInputDefaultValue">
                          <Form.Label>Default Value</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter default value"
                            value={defaultValue}
                            onChange={(e) => setDefaultValue(e.target.value)}
                          />
                        </Form.Group>
                        <Form.Group controlId="formInputPlaceholder">
                          <Form.Label>Input Placeholder</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter input placeholder"
                            value={inputPlaceholder}
                            onChange={(e) => setInputPlaceholder(e.target.value)}
                          />
                        </Form.Group>
                      </div>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowTextareaModal(false)}>Close</Button>
                    <Button variant="primary" onClick={() => {
                      setShowTextareaModal(false);
                      console.log(selectedOption); // Selected option from Contact Field
                      console.log(selectedValidation); // Selected validation option
                    }}>
                      Submit
                    </Button>
                  </Modal.Footer>
                </Modal><Modal show={showurlModal} onHide={() => setShowurlModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="row">
              <div className="col-auto" onClick={handleContactFieldClick} style={{ cursor: 'pointer' }}>Contact Field</div>
              <div className="col-auto" onClick={handleValidationClick} style={{ cursor: 'pointer' }}>Validation</div>
              <div className="col-auto" onClick={handleGeneralClick} style={{ cursor: 'pointer' }}>General</div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedOption === 'Contact Field' && (
            <Form.Group controlId="formInputLabel">
            <Form.Label>Choose field</Form.Label>
            <Form.Control
              as="select"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
            >
              <option value=""></option>
              <option value="Option 1">Email</option>
              <option value="Option 2">Mobile</option>
              <option value="Option 3">City</option>
              <option value="Option 4">State</option>
              
            </Form.Control>
          </Form.Group>
          
          )}
          {selectedOption === 'Validation' && (
            <div>
              <div className="d-flex align-items-center">
                <span>Required</span>
                <Button
                  variant={selectedValidation === 'Yes' ? 'success' : 'outline-secondary'}
                  onClick={() => setSelectedValidation('Yes')}
                  style={{ marginRight: '-45px' }}
                >
                  Yes
                </Button>
                <Button
                  variant={selectedValidation === 'No' ? 'danger' : 'outline-secondary'}
                  onClick={() => setSelectedValidation('No')}
                >
                  No
                </Button>
              </div>
            </div>
          )}
          {selectedOption === 'General' && (
            <div>
              <Form.Group controlId="formInputLabel">
                <Form.Label>Label</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter label"
                  value={label}
                  onChange={(e) => setLabel(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formInputDefaultValue">
                <Form.Label>Default Value</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter default value"
                  value={defaultValue}
                  onChange={(e) => setDefaultValue(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formInputPlaceholder">
                <Form.Label>Input Placeholder</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter input placeholder"
                  value={inputPlaceholder}
                  onChange={(e) => setInputPlaceholder(e.target.value)}
                />
              </Form.Group>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowurlModal(false)}>Close</Button>
          <Button variant="primary" onClick={() => {
            setShowurlModal(false);
            console.log(selectedOption); // Selected option from Contact Field
            console.log(selectedValidation); // Selected validation option
          }}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

    </>

{showActionsInput && (
                        <div className="form-group row">
                            <div className="col">
                                <select
                                    className="form-control"
                                    value={selectedAction}
                                    onChange={(e) => handleActionSelect(e.target.value)}
                                    style={{ width: '300px', marginLeft: '10px' }}
                                >
                                    <option value="">Select an Action</option>
                                    <option value="Download Asset">Download Asset</option>
                                    <option value="Send Email to User">Send Email to User</option>
                                    {/* Add more options as needed */}
                                </select>
                            </div>
                        </div>
                    )} 



</div>
</div>
</div>
        
    );
};

export default Forms;
